import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  createVendorLoading: false,
  editVendorLoading: false,
  error: null,
  totalCars: 0,
  searchText: "",
  openedDropdownRowId: null,
  vendorDetails: {
    dataSource: [],
    columns: [],
    headers: "",
    totalCars: 0
  },
  expandedRowDetails: {
    loading: false,
    dataSource: [],
    columns: []
  },
  preFilledDetails: null,
  pagination: { pageSize: 20, currentPage: 1 }
};

const fetchVendorStart = (state) => ({
  ...state,
  loading: true
});

const fetchVendorSuccess = (state, action) => ({
  ...state,
  loading: false,
  totalCars: action.data.totalCars,
  vendorDetails: {
    dataSource: action.data.dataSource,
    columns: action.data.columns,
    headers: action.data.headers,
    totalCars: action.data.totalCars
  },
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  }
});

const fetchVendorFailure = (state) => ({
  ...state,
  loading: false
});

const createVendorStart = (state) => ({
  ...state,
  createVendorLoading: true
});

const createVendorSuccess = (state) => ({
  ...state,
  createVendorLoading: false,
  error: null
});

const createVendorFailure = (state, action) => ({
  ...state,
  createVendorLoading: false,
  error: action?.error.status
});

const setVendorDataStart = (state) => ({
  ...state,
  editVendorLoading: true
});
const setVendorDataSuccess = (state, action) => ({
  ...state,
  editVendorLoading: false,
  preFilledDetails: action.data
});
const setVendorDataFail = (state) => ({
  ...state,
  editVendorLoading: false
});
const resetPrefilledData = (state) => ({
  ...state,
  preFilledDetails: null
});

const fetchVendorDropdownStart = (state) => ({
  ...state,
  expandedRowDetails: {
    ...state.expandedRowDetails,
    loading: true
  }
});

const fetchVendorDropdownSuccess = (state, action) => ({
  ...state,
  expandedRowDetails: {
    loading: false,
    dataSource: action.data.dataSource,
    column: action.data.columns
  }
});

const fetchVendorDropdownFail = (state) => ({
  ...state
});

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});

const setSearchInput = (state, action) => ({
  ...state,
  searchText: action.data,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const setPageSize = (state, action) => {
  const {
    vendorDetails: { totalCars },
    pagination: { currentPage }
  } = state;
  const lastPage = totalCars / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};

const setOpenedDropdownId = (state, action) => ({
  ...state,
  openedDropdownRowId: action.id
});

const resetVendor = () => initialState;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PIM_VENDOR_START:
      return fetchVendorStart(state, action);

    case actionTypes.FETCH_PIM_VENDOR_SUCCESS:
      return fetchVendorSuccess(state, action);

    case actionTypes.FETCH_PIM_VENDOR_FAIL:
      return fetchVendorFailure(state, action);

    case actionTypes.CREATE_PIM_VENDOR_START:
      return createVendorStart(state, action);

    case actionTypes.CREATE_PIM_VENDOR_SUCCESS:
      return createVendorSuccess(state, action);

    case actionTypes.CREATE_PIM_VENDOR_FAIL:
      return createVendorFailure(state, action);

    case actionTypes.SET_PIM_VENDOR_DATA_START:
      return setVendorDataStart(state, action);

    case actionTypes.SET_PIM_VENDOR_DATA_SUCCESS:
      return setVendorDataSuccess(state, action);

    case actionTypes.SET_PIM_VENDOR_DATA_FAIL:
      return setVendorDataFail(state, action);

    case actionTypes.RESET_PREFILLED_DATA:
      return resetPrefilledData(state, action);

    case actionTypes.FETCH_PIM_VENDOR_DROPDOWN_START:
      return fetchVendorDropdownStart(state, action);

    case actionTypes.FETCH_PIM_VENDOR_DROPDOWN_SUCCESS:
      return fetchVendorDropdownSuccess(state, action);

    case actionTypes.FETCH_PIM_VENDOR_DROPDOWN_FAIL:
      return fetchVendorDropdownFail(state, action);

    case actionTypes.SET_PIM_VENDOR_CURRENT_PAGE:
      return setCurrentPage(state, action);

    case actionTypes.SET_PIM_VENDOR_SEARCH_INPUT:
      return setSearchInput(state, action);

    case actionTypes.SET_PIM_VENDOR_PAGE_SIZE:
      return setPageSize(state, action);

    case actionTypes.SET_PIM_VENDOR_DROPDOWN_ID:
      return setOpenedDropdownId(state, action);

    case actionTypes.RESET_PIM_VENDOR:
      return resetVendor();
    default:
      return state;
  }
};

export default reducer;
